module.exports = __webpack_public_path__ + "static/media/dashboard-greetings.a29374fb.svg";